import { render, staticRenderFns } from "./reel-filter.vue?vue&type=template&id=318b22d6&scoped=true&"
import script from "./reel-filter.vue?vue&type=script&lang=js&"
export * from "./reel-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b22d6",
  null
  
)

export default component.exports